import { render, staticRenderFns } from "./logo-primary.vue?vue&type=template&id=15c944a2&scoped=true"
import script from "./logo-primary.vue?vue&type=script&lang=js"
export * from "./logo-primary.vue?vue&type=script&lang=js"
import style0 from "./logo-primary.vue?vue&type=style&index=0&id=15c944a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c944a2",
  null
  
)

export default component.exports